(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-rewards-progress"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('cart-rewards-section')) return;
  let latestCart = null;
  let timer;
  let revision = 0;
  let requestPending = false;
  let dirty = false;
  const nativeFetch = window.fetch;
  const elements = () => document.querySelectorAll('cart-rewards-section');
  const root = () => window.Shopify?.routes?.root || '/';
  const mutationURL = input => {
    try {
      const url = new URL(input instanceof Request ? input.url : input, location.href);
      return url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname);
    } catch { return false; }
  };
  const refresh = async () => {
    if (requestPending) { dirty = true; return; }
    if (!elements().length) return;
    requestPending = true;
    const currentRevision = revision;
    try {
      const response = await nativeFetch.call(window, `${root()}cart.js`, { credentials:'same-origin', cache:'no-store' });
      if (!response.ok) throw new Error(`Cart ${response.status}`);
      const cart = await response.json();
      if (currentRevision === revision) {
        latestCart = cart;
        elements().forEach(element => element.update(cart));
      } else dirty = true;
    } catch (error) {
      console.warn('[cart-rewards-section]', error);
    } finally {
      requestPending = false;
      if (dirty) { dirty = false; schedule(); }
    }
  };
  const schedule = () => {
    revision += 1;
    clearTimeout(timer);
    timer = setTimeout(refresh, 80);
  };
  class CartRewardsSection extends HTMLElement {
    connectedCallback() {
      this.config = JSON.parse(this.querySelector('[data-cr-config]').textContent);
      this.update(latestCart || { [this.config.basis]: this.config.amount, currency:this.config.currency });
      schedule();
    }
    update(cart) {
      const config = this.config;
      const thresholds = config.thresholds;
      if (!thresholds.every((value,index) => value > 0 && (!index || value > thresholds[index - 1]))) {
        this.hidden = true;
        return;
      }
      this.hidden = false;
      const amount = Math.max(0, Number(cart[config.basis]) || 0);
      const stage = thresholds.filter(value => amount >= value).length;
      const target = thresholds[Math.min(stage,2)];
      const start = stage === 0 ? 0 : thresholds[Math.min(stage,2) - 1];
      const progress = stage === 3 ? 100 : Math.max(0, Math.min(100, (amount - start) / (target - start) * 100));
      const currency = cart.currency || config.currency;
      const formatMoney = value => currency === 'USD'
        ? '$' + new Intl.NumberFormat('en-US', {maximumFractionDigits:2}).format(value / 100)
        : new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency,minimumFractionDigits:0,maximumFractionDigits:2}).format(value / 100);
      const money = formatMoney(Math.max(0,target - amount));
      this.querySelector('.crs-progress__start').textContent = formatMoney(start);
      this.querySelector('.crs-progress__end').textContent = formatMoney(target);
      const reward = this.querySelector('.crs-progress__reward');
      const prompt = this.querySelector('.crs-progress__prompt');
      this.dataset.stage = String(stage);
      this.style.setProperty('--cr-fill', `${progress}%`);
      this.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', String(Math.round(progress)));
      const rewardText = stage === 0 ? '' : config.rewards[stage] || '';
      const rewardLabel = this.querySelector('.crs-progress__reward-text');
      const template = config.prompts[stage] || '';
      const offer = config.offers?.[stage] || '';
      const signature = JSON.stringify([template,money,offer]);
      if (rewardLabel.textContent !== rewardText) rewardLabel.textContent = rewardText;
      reward.hidden = !rewardText;
      if (this.promptSignature !== signature) {
        const fragment = document.createDocumentFragment();
        template.split(/(\[amount\]|\[offer\])/g).forEach(part => {
          if (part === '[amount]' || part === '[offer]') {
            const span = document.createElement('span');
            span.className = 'crs-progress__highlight';
            span.textContent = part === '[amount]' ? money : offer;
            fragment.append(span);
          } else fragment.append(document.createTextNode(part));
        });
        prompt.replaceChildren(fragment);
        this.promptSignature = signature;
      }
      prompt.hidden = !template;
    }
  }
  window.fetch = function (...args) {
    const promise = nativeFetch.apply(this,args);
    if (mutationURL(args[0])) promise.then(response => { if (response.ok) schedule(); }, () => {});
    return promise;
  };
  const nativeOpen = XMLHttpRequest.prototype.open;
  const nativeSend = XMLHttpRequest.prototype.send;
  const cartRequests = new WeakSet();
  XMLHttpRequest.prototype.open = function (method,url,...args) {
    cartRequests.delete(this);
    if (mutationURL(url)) cartRequests.add(this);
    return nativeOpen.call(this,method,url,...args);
  };
  XMLHttpRequest.prototype.send = function (...args) {
    if (cartRequests.has(this)) this.addEventListener('load', () => {
      if (this.status >= 200 && this.status < 300) schedule();
    }, {once:true});
    return nativeSend.apply(this,args);
  };
  ['cart:updated','cart:change','cart:refresh','shopify:section:load'].forEach(name => document.addEventListener(name,schedule));
  window.addEventListener('pageshow',schedule);
  window.addEventListener('focus',schedule);
  window.CartRewardsSection = { refresh:schedule };
  customElements.define('cart-rewards-section',CartRewardsSection);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
